import React
// { useEffect, useState } 
from "react";
import { getNumberWithUnit } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { NoDataFound, Spinner } from "@public/ui-toolkit";
import { createRoom, getAllocatorUsers } from "../../FundDetail/actions";
import MyFundsCard from "@hedgefund/shared/src/MyFundsCard";
import { followFund } from "../../SearchHedgeFund/actions";

const MyFundsTab = ({ loading, investedFunds,isFooterShow, pageSize, loadData }) => {
  const dispatch = useDispatch();
  // const fundState = useSelector((state) => state.investedFunds);
  const fundDetailState = useSelector((state) => state.hedgeFundDetailStore);
  const { allocatorUsers, userLoading } = fundDetailState;
  // const [firstCall, setFirstCall] = useState(true);
  // useEffect(() => {
  //   setFirstCall(false);
  //   // loadData();
  // }, []);
  
  // useEffect(() => {
  //   if (!firstCall) {
  //     loadData();
  //   }
  // }, [pageSize]);
  const followFundHandler = (fundId, follow) => {
    dispatch(followFund(fundId, follow));
  };

  const getAllocatorUserList = (id) => {
    dispatch(getAllocatorUsers(id));
  }
  const createAllocatorRoom = (body, callback) => {
    dispatch(createRoom(body, callback))
  }
  return (
    <div className="mt-5">
      <div className="row gy-4" style={{ padding : "3px" }}>
        {loading ? (
          <Spinner className="text-center" />
        ) : investedFunds?.length ? (
          investedFunds?.map((fund, index) => (
            <div className="col-xl-4 col-lg-6 col-md-6" key={index}>
              <MyFundsCard
                isFooterShow={isFooterShow}
                btnName={fund?.followed ? "Followed" : "Follow"}
                fund={fund}
                getNumberWithUnit={getNumberWithUnit}
                userLoading={userLoading}
                allocatorUsers={allocatorUsers}
                getAllocatorUsers={getAllocatorUserList}
                createRoom={createAllocatorRoom}
                followFundHandler={followFundHandler}
              />
            </div>
          ))
        ) : (
          <NoDataFound message="No Activity Found!" />
        )}
      </div>
    </div>
  );
};

export default MyFundsTab;
